export enum FeatureType {
  None = "None",
  Parametrisation = "Parametrisation",
  ZinsMatrix = "ZinsMatrix",
  ConsoleWriter = "ConsoleWriter",
  KpiCheck = "KpiCheck",
  Application = "Application",
  DocuSign = "DocuSign"
}